import { Component, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '../../services/translate.service';
import { BaseButtonComponent } from '../buttons/base-button.component';
import { TableNeed } from '../../utils/table-needs';

// What the party needs of its table, as chips to tick ("Vi har med hund"): the booking's guests step and the walk-in
// queue. Only the needs the venue offers and has tables for (samwise /guest/table_needs); nothing without any.
@Component({
  selector: 'app-table-needs-chips',
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  template: `
    @if (offered().length) {
      <div>
        <div class="text-base font-medium">{{ getString('Något vi ska tänka på?') }}</div>
        <p class="text-sm text-theme-text2 mt-1">{{ getString('Så ger vi er ett bord som passar.') }}</p>
        <div class="flex flex-wrap gap-2 mt-3">
          @for (need of offered(); track need.code) {
            <app-base-button stateColorScheme="surface" (onClick)="toggle.emit(need.code)">
              <div class="flex items-center gap-2 px-4 py-2 rounded-full border"
                   [class.bg-theme-primary]="isPicked(need.code)"
                   [class.text-theme-contrast]="isPicked(need.code)"
                   [class.border-theme-primary]="isPicked(need.code)"
                   [class.border-theme-divider]="!isPicked(need.code)">
                <i class="fas text-sm" [ngClass]="isPicked(need.code) ? 'fa-check' : need.icon"></i>
                <span>{{ getString(need.label) }}</span>
              </div>
            </app-base-button>
          }
        </div>
      </div>
    }
  `
})
export class TableNeedsChipsComponent {
  private translate = inject(TranslateService);
  offered = input<TableNeed[]>([]);
  picked = input<string[]>([]);
  toggle = output<string>();

  getString(s: string) {
    return this.translate.getString(s);
  }

  isPicked(code: string): boolean {
    return this.picked().includes(code);
  }
}
